module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADASURBVDiNrZTREcIgEAXvUkE6kBJiBaYES0gJ6cBSLEWtwBKSDrCD9SOoxASU053hB7jlMdwgkgGogSEMl9ubBWh50VoEDjgCPhL5MPddMqAjjwe6kqt8osmJTgWiISVpCiSLVFXkSkdNsyr6iVi0MdQ/a2KRM4iWNcybr/jlqiDpRaS2JAq1okwtfzWKRERuIrLVEM8ZJQ/Gvz2/ArXYmjFm1NQK0/+ze5u+qOq56AjWv5N9cdYg60N/eeCQ23sHndJsDZyfedIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/msg.png
// module id = QqtN
// module chunks = 1